import { render, staticRenderFns } from "./LeagueSeason.vue?vue&type=template&id=6464a0b8"
import script from "./LeagueSeason.vue?vue&type=script&lang=js"
export * from "./LeagueSeason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports